import dayjs from 'dayjs';
import { getCurrentMonthCreatedDateFilter } from './orderListFilters';

export const defaultValueAdd = {
  order_id: null,
  payment_status: 0,
  is_delivery_type: 1,
  order_source: 1,
  total_discount: 0,
  is_discount_percent: 0,
  is_active: 1,
  total_vat: 0,
  is_cash_money: 0,
  commissions: [],
  commission_plan: null,
  button_type: 'save',
  is_can_stockout: 1,
  is_can_collect_money: 1,
  is_can_create_receiveslip: 1,
  is_can_edit: 1,
  is_plus_point: 1,
  is_invoice: 0,
  receiving_date: dayjs().format('DD/MM/YYYY'),
  additional_note: '',

  data_payment: [],
  return_money: 0,
};

export const typePromotionValues = [
  {
    label: 'đ',
    value: 1,
  },
  {
    label: '%',
    value: 2,
  },
];

export const orderAddress = {
  STORE: 1,
  HOME: 2,
};

export const orderAddressOpts = [
  { label: 'Cửa hàng', value: orderAddress.STORE },
  { label: 'Tại nhà', value: orderAddress.HOME },
];

export const deliveryStatusClassNames = {
  success: 'bw_label_outline_success',
  primary: 'bw_label_outline_primary',
  warning: 'bw_label_outline_warning',
  danger: 'bw_label_outline_danger',
};

export const paymentFormType = {
  ALL: 0,
  CASH: 1,
  BANK: 2,
  PARTNER: 3,
  POS: 4,
  COD: 5,
};

export const paymentStatus = {
  ALL: -1,
  NOT_PAID: 0,
  PAID: 1,
  PARTIALLY_PAID: 2,
};

export const statusPaymentOpts = [
  { value: paymentStatus.ALL, label: 'Tất cả' },
  { value: paymentStatus.NOT_PAID, label: 'Chưa thanh toán' },
  { value: paymentStatus.PAID, label: 'Đã thanh toán' },
  { value: paymentStatus.PARTIALLY_PAID, label: 'Thanh toán 1 phần' },
];

export const salesReturnStatus = {
  ALL: -1,
  NOT_RETURNED: 0,
  RETURNED: 1,
};

export const salesReturnStatusOpts = [
  { value: salesReturnStatus.ALL, label: 'Tất cả' },
  { value: salesReturnStatus.RETURNED, label: 'Đã trả lại' },
  { value: salesReturnStatus.NOT_RETURNED, label: 'Chưa trả' },
];

export const vatExportStatus = {
  ALL: -1,
  EXPORTED: 1,
  NOT_EXPORTED: 0,
};

export const vatExportStatusOpts = [
  { value: vatExportStatus.ALL, label: 'Tất cả' },
  { value: vatExportStatus.EXPORTED, label: 'Đã xuất' },
  { value: vatExportStatus.NOT_EXPORTED, label: 'Chưa xuất' },
];

export const getDefaultOrderListFilter = (referenceDate) => ({
  search: '',
  ...getCurrentMonthCreatedDateFilter(referenceDate),
  store_id: null,
  company_id: null,
  order_type: null,
  payment_status: paymentStatus.ALL,
  sales_return_status: salesReturnStatus.ALL,
  vat_export_status: vatExportStatus.ALL,
  page: 1,
  order_type_id: null,
  business_id: null,
  store: null,
  is_delivery_type: null,
  provice_id: null,
});

export const defaultValueFilter = getDefaultOrderListFilter();

export const orderType = {
  NORMAL: 1, // Đơn hàng tại quày
  INSTALLMENT_OFFLINE: 2, // Đơn hàng trả góp offline
  INSTALLMENT_ONLINE: 3, // Đơn hàng trả góp online
  SHOPEE: 4, // Đơn hàng Shopee
  LAZADA: 5, // Đơn hàng Lazada
  WEB: 6, // Đơn hàng bán trên web
  WHOLESALE_ORDERS: 7, // Đơn hàng bán buôn
  TRADE_IN: 8, // Đơn hàng thu cũ đổi mới
  PREORDER: 10, // Đơn hàng đặt trước
  OTHER: 0, // Đơn hàng khác
  INTERNAL: 11, // Đơn nội bộ
};

export const orderTypeId = {
  RETAIL: 33, // Đơn hàng bán lẻ
  ORDER_BOOKING: 39, // Đơn hàng đặt trước
  SD_PREORDER: 32, // Đơn hàng đặt trước từ App SD
  ERP_PREORDER: 31, // Đơn hàng đặt trước từ App ERP
  LDP_PREORDER: 30, // Đơn hàng đặt trước từ LDP
};

export const preOrderOrderTypeIds = [
  orderTypeId.ORDER_BOOKING,
  orderTypeId.SD_PREORDER,
  orderTypeId.ERP_PREORDER,
  orderTypeId.LDP_PREORDER,
];

const normalizeOrderTypeLabel = (label = '') =>
  String(label || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/đ/g, 'd')
    .trim();

export const isBookingOrderType = (type, orderTypeIdValue) =>
  Number(type) === orderType.PREORDER || preOrderOrderTypeIds.includes(Number(orderTypeIdValue));

export const isPreOrderTypeLabel = (label = '') => {
  const normalizedLabel = normalizeOrderTypeLabel(label);

  return (
    normalizedLabel.includes('preorder') ||
    normalizedLabel.includes('pre order') ||
    normalizedLabel.includes('dat truoc') ||
    normalizedLabel.includes('don hang dat truoc')
  );
};

export const getOrderStatusDisplayName = (order = {}) => {
  const statusName = order?.order_status_name || order?.status_name || order?.name || '';
  const normalizedStatusName = normalizeOrderTypeLabel(statusName);
  const normalizedOrderTypeName = normalizeOrderTypeLabel(
    order?.order_type_name || order?.order_type_label || order?.type_name || '',
  );
  const bookingDraftStatusNames = ['phieu tam', 'don hang moi', 'don moi'];
  const isBookingOrder =
    isBookingOrderType(order?.order_type, order?.order_type_id) ||
    normalizedOrderTypeName.includes('dat truoc') ||
    normalizedOrderTypeName.includes('preorder') ||
    normalizedOrderTypeName.includes('pre order');

  if (isBookingOrder && bookingDraftStatusNames.includes(normalizedStatusName)) {
    return 'Đơn đang đặt';
  }

  return statusName;
};

export const INSTALLMENT_TYPE = {
  CARD: 1,
  COMPANY: 2,
};

export const InstallmentTypeOptions = [
  { label: 'Qua thẻ tín dụng', value: INSTALLMENT_TYPE.CARD },
  { label: 'Qua công ty tài chính', value: INSTALLMENT_TYPE.COMPANY },
];

export const INSTALLMENT_PAYMENT_METHODS = [
  {
    label: 'Onepay',
    value: 1,
    logo: 'https://play-lh.googleusercontent.com/mvedVCbQg6ADKUYYraVLOlmOfOy2Rz66kEPvbmxt5xZ2TTa90Go9jBD2dJrwWmEo5g8',
  },
  { label: 'Payoo', value: 2, logo: 'https://cdn.tgdd.vn/2020/06/GameApp/payoo-1-200x200.jpg' },
  {
    label: 'Kredivo',
    value: 3,
    logo: 'https://yt3.googleusercontent.com/0J7KUb-ZLoJTgeikh1v44xYLtmCfRn8gNmNEUTTmFJQju2aZJVEfRXLnzKMhmBVt_S08T4tgQQ=s900-c-k-c0x00ffffff-no-rj',
  },
];

export const productOutputType = {
  RETAIL: 7, //Xuất bán lẻ
  PREORDER: 13, // Đơn hàng đặt trước
};

export const ONEPAY_RESPONSE_MESSAGE = {
  0: 'Giao dịch thành công',
  1: 'Ngân hàng từ chối cấp phép giao dịch',
  2: 'Ngân hàng phát hành thẻ từ chối cấp phép giao dịch',
  3: 'Không nhập được kết quả phản hồi từ Tổ chức phát hành thẻ',
  4: 'Tháng/Năm hết hạn của thẻ không đúng hoặc thẻ đã hết hạn sử dụng',
  5: 'Số dư/Hạn mức của thẻ không đủ để thanh toán',
  6: 'Không nhận được kết quả phản hồi từ Tổ chức phát hành thẻ',
  7: 'Lỗi trong quá trình xử lý giao dịch của Ngân hàng',
  8: 'Ngân hàng phát hành thẻ không hỗ trợ thanh toán trực tuyến',
  9: 'Tên chủ thẻ/tài khoản không hợp lệ',
  10: 'Thẻ hết hạn/Thẻ bị khóa',
  11: 'Thẻ/Tài khoản chưa đăng ký dịch vụ hỗ trợ thanh toán trực tuyến',
  12: 'Tháng/Năm phát hành hoặc hết hạn của thẻ không hợp lệ',
  13: 'Giao dịch vượt quá hạn mức thanh toán trực tuyến theo quy định của Ngân hàng',
  14: 'Số thẻ không hợp lệ',
  21: 'Số dư tài khoản không đủ để thanh toán',
  22: 'Thông tin tài khoản không hợp lệ',
  23: 'Thẻ/Tài khoản bị khóa hoặc chưa được kích hoạt',
  24: 'Thông tin thẻ/tài khoản không hợp lệ',
  25: 'Mã xác thực OTP không hợp lệ',
  26: 'Mã xác thực OTP đã hết hiệu lực',
  98: 'Xác thực giao dịch bị hủy',
  99: 'Người dùng hủy giao dịch',
  B: 'Lỗi trong quá trình xác thực giao dịch của Ngân hàng phát hành thẻ',
  D: 'Lỗi trong quá trình xác thực giao dịch của Ngân hàng phát hành thẻ',
  F: 'Xác thực giao dịch không thành công',
  U: 'Xác thực mã CSC không thành công',
  Z: 'Giao dịch bị từ chối',
  253: 'Hết thời hạn nhập thông tin thanh toán',
};
